module.exports = __webpack_public_path__ + "static/gite-eb4d402f637dac42091aa60f522e2142.jpg";